export function Work() {

    return <section className="py-1 text-light">
            <div className="container">
                <div className="row" style={{height: "100px"}}></div>
                <div className="row justify-content-left">
                    <div className="col-lg justify-content-center">
                        <h1>Notable Works</h1>
                        <ul>
                            <li>
                                <a href="https://github.com/Isentropy/brevity">Brevity</a>: An Interpreted EVM Language for DeFi workflows and AI Agents. Presented at Web3 Summit Berlin 2025, EthDenver 2026.
                            </li>
                            <li>
                                <a href="https://github.com/isentropy/monet">Monet (2017)</a>: an early open-source java command line Ethereum wallet that easily values, transfers, and creates ERC20 tokens.
                            </li>
                        </ul>
                        <h1>Blockchain Consulting</h1>
                        <ul>
                            <li>
                                <a href="https://beaconprotocol.com/">Beacon Protocol</a>: Led EVM and SVM smart contract development, wrote client lib for data sharing and monetezation protocol for AI, MCP server. Integrations with Lit Protocol, Monad, 0G.
                            </li>
                            <li>
                                <a href="https://www.crunchbase.com/organization/free-market-labs">Free Market Labs</a>: Architected EVM sweep vehicle Pathfinder using <a href="https://github.com/Isentropy/brevity">Brevity</a>.
                            </li>
                            <li>
                                <a href="https://streamr.network">Streamr</a>: Led Ethereum development. Developed smart contracts for Data Unions, Marketplace, DeFi integrations (Uniswap v1,2,3 and Bancor)
                            </li>
                        </ul>
                        <h1>Other Consulting</h1>
                        <ul>
                            <li>
                                 <a href="https://www.bloomberg.com">Bloomberg</a>: Core developer of <a href="https://www.bloomberg.com/professional/products/compliance/vault/">Bloomberg Vault</a> distributed compliance system. Built MITM proxy to decrypt
SSL, NoSQL tools.
                            </li>
                            <li>
                                <a href="https://blackrock.com">Blackrock</a>: Developed infrastructure database jobs.                       
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
        
}

/*

                            <li>
                                Authored <a href="https://github.com/isentropy/accumulo-collections">Accumulo Collections</a>: a lightweight library that encapsulates distributed features of Accumulo in the Java Collections interface. Presented at Apache Accumulo Summit 2016.
                            </li>

*/